
import Api from "@/services/Api";

const state = {
	sites: [],
	campaigns: [],
	lists: [],
	graphdata: [],
	subscribers: [],
	listsubscribers: []
};
const getters = {
	sites: state => state.sites,
	campaigns: state => state.campaigns,
	lists: state => state.lists,
	graphdata: state => state.graphdata,
	subscribers: state => state.subscribers.data,
	listsubscribers: state => state.listsubscribers
};
const mutations = {
	GET_SITES(state, { payload, context }) {
		let url = '/sites';

		if (payload.query) {
			// Filter all falsy values ( "", 0, false, null, undefined )
			payload.query = Object.entries(payload.query).reduce((a,[k,v]) => (v ? (a[k]=v, a) : a), {})
			const params = new URLSearchParams(payload.query).toString();
			url = `/sites?${params}`;
		}

		context.loading = true;
		Api.get(url)
			.then(resp => {
				context.loading = false;
				state.sites = resp.data;
			})
			.catch(err => {
				context.loading = false;
				return err.response.data.message;
			});
	},
	SEARCH_SITE(state, payload) {
		let url = "/sites";
		let query = payload.query;

		if (query) {
			// Filter all falsy values ( "", 0, false, null, undefined )
			query = Object.entries(query).reduce((a,[k,v]) => (v ? (a[k]=v, a) : a), {})
			const params = new URLSearchParams();

			// eslint-disable-next-line no-unused-vars
			Object.keys(query).forEach((key, index) => {
				if (Array.isArray(query[key])) {
					query[key].map(value => params.append(`${key}[]`, value));
				} else {
					params.append(`${key}`, query[key]);
				}
			})

			url = `/sites?${params}`;
		}

		Api.get(url)
			.then(resp => {
				state.sites = resp.data;
				payload.context.loading = false;
			})
			.catch(err => {
				payload.context.loading = false;
				return err.response.data.message;
			});
	},
	GET_OPEN_CLICK_DATA(state, payload) {
		Api.get(`/sites/${payload.siteId}/open-click?${payload.query}`)
			.then(resp => {
				state.graphdata = resp.data.data[0];
			})
			.catch(err => {
				return err.response.data.message;
			});
	},
	GET_LISTS(state, siteId) {
		Api.get(`/sites/${siteId}/lists`)
			.then(resp => {
				state.lists = resp.data;
			})
			.catch(err => {
				return err.response.data.message;
			});
	},
	GET_SUBSCRIBERS(state, payload) {
		payload.context.loading = true;
		Api.get(`/sites/${payload.siteId}/subscribers`)
			.then(resp => {
				payload.context.loading = false;
				state.subscribers = resp.data;
			})
			.catch(err => {
				payload.context.loading = false;
				return err.response.data.message;
			});
	},
	GET_LIST_SUBSCRIBERS(state, payload) {
		Api.get(`/sites/${payload.siteId}/lists/${payload.listId}/subscribers`)
			.then(resp => {
				state.listsubscribers = resp.data;
			})
			.catch(err => {
				return err.response.data.message;
			});
	},
	PAGINATE_LIST_SUBSCRIBERS(state, payload) {
		Api.get(
			`/sites/${payload.siteId}/lists/${
				payload.listId
			}/subscribers?page=${payload.page}`
		)
			.then(resp => {
				state.listsubscribers = resp.data;
			})
			.catch(err => {
				return err.response.data.message;
			});
	},
	PAGINATE_LISTS(state, payload) {
		Api.get(`/sites/${payload.siteId}/lists?page=${payload.page}`)
			.then(resp => {
				state.lists = resp.data;
			})
			.catch(err => {
				return err.response.data.message;
			});
	},
	PAGINATE_SUBSCRIBERS(state, payload) {
		payload.context.loading = true;
		Api.get(`/sites/${payload.siteId}/subscribers?page=${payload.page}`)
			.then(resp => {
				payload.context.loading = false;
				state.subscribers = resp.data;
			})
			.catch(err => {
				payload.context.loading = false;
				return err.response.data.message;
			});
	},
	PAGINATE_SITES(state, payload) {
		Api.get(`/sites?page=${payload}`)
			.then(resp => {
				state.sites = resp.data;
			})
			.catch(err => {
				return err.response.data.message;
			});
	},
	GET_CAMPAIGNS(state, {site, page = 1}) {
		let queryString = '';
		if (page && page != 1) {
			queryString = `?page=${page}`;
		}
		Api.get(`/sites/${site}/campaigns${queryString}`)
			.then(resp => {
				state.campaigns = resp.data;
			})
			.catch(err => {
				return err.response.data.message;
			});
	},
};
const actions = {
	GET_SITES({ commit }) {
		commit("GET_SITES");
	},
	GET_LISTS({ commit }, payload) {
		commit("GET_LISTS", payload);
	},
	GET_CAMPAIGNS({ commit }, payload) {
		commit("GET_CAMPAIGNS", payload);
	},
	GET_OPEN_CLICK_DATA({ commit }, payload) {
		commit("GET_OPEN_CLICK_DATA", payload);
	}
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};
